import { LoadingUtil } from 'lib-vue-v2/util';
import { useMessageBox } from "lib-vue-v2/composables";
import { Resource as CommonResource } from "@/models/Message/Resource/CommonResource";
import { AndroidAgentSetting } from '@/views/Mobile/Android/GoogleAccountSetting/model/AndroidAgentSetting';
import { BaseResponseDto } from "./BaseResponseDto";

// c#からくるレスポンス
interface UpdateAndroidDeviceSettingResponseDto extends BaseResponseDto {
    result: boolean;
}

// メッセージ用
const { showMessageBox } = useMessageBox();

export default function useUpdateAndroidAgentSettingPackage() {
    /**
     * IPC経由で端末設定の更新処理を行います（オンプレミス専用）
     * @param oldSetting 変更前の設定リスト
     * @param newSetting 変更後の設定リスト
     * @returns 処理の成否
     */
    const executeAsync = async (oldSetting: AndroidAgentSetting[], newSetting: AndroidAgentSetting[]): Promise<boolean> => {
        try {
            LoadingUtil.Start();

            // 分離した関数を呼び出して差分リクエストデータを作成
            const requestDto = createRequestData(oldSetting, newSetting);
            const jsonRequest = JSON.stringify(requestDto);

            const jsonResponse = await window.chrome?.webview?.hostObjects.class.UpdateAndroidDeviceSettingInfo(jsonRequest);

            if (jsonResponse === undefined) {
                showErrorMessage();
                return false;
            }

            const response = JSON.parse(jsonResponse) as UpdateAndroidDeviceSettingResponseDto;

            if (!response.isSuccess || !response.result) {
                showErrorMessage();
                return false;
            }

            return true;
        }
        catch {
            showErrorMessage();
            return false;
        }
        finally {
            LoadingUtil.Stop();
        }
    }

    const createRequestData = (oldSetting: AndroidAgentSetting[], newSetting: AndroidAgentSetting[]) => {
        const oldSettingMap = new Map(
            oldSetting.map(item => [item.agentNo, JSON.stringify(item.setting)])
        );

        const updateSetting = newSetting.filter(newItem => {
            const oldSettingStr = oldSettingMap.get(newItem.agentNo);
            // oldSettingに存在しない（新規） or settingの内容が異なる（変更）
            return oldSettingStr === undefined || oldSettingStr !== JSON.stringify(newItem.setting);
        }).map(item => ({
            agentId: item.agentNo,
            agentSetting: JSON.stringify(item.setting)
        }));

        const newAgentNoSet = new Set(newSetting.map(item => item.agentNo));
        const deleteSetting = oldSetting.filter(oldItem => !newAgentNoSet.has(oldItem.agentNo)).map(e => e.agentNo);

        return {
            updateSetting,
            deleteSetting
        };
    };

    // エラーメッセージ表示
    const showErrorMessage = (): void => {
        // データの更新に失敗しました。
        showMessageBox(
            CommonResource.CommonResource.getInstance().getMsgInfo(
                CommonResource.MsgID.Common_FailedApplySetting
            )
        );
    }

    // 外部公開
    return {
        executeAsync
    }
}
